import { render, staticRenderFns } from "./ShowPricing.vue?vue&type=template&id=763424e3"
import script from "./ShowPricing.vue?vue&type=script&lang=js"
export * from "./ShowPricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports